export const PLATFORM_ROLES = ['user', 'client', 'animator', 'admin', 'superadmin'] as const;

export type PlatformRole = (typeof PLATFORM_ROLES)[number];

export const ADMIN_PLATFORM_ROLES: PlatformRole[] = ['admin', 'superadmin'];

export function isPlatformRole(value: string): value is PlatformRole {
  return (PLATFORM_ROLES as readonly string[]).includes(value);
}

export function normalizePlatformRoles(input: unknown): PlatformRole[] {
  const values = Array.isArray(input) ? input : [input];

  return values
    .filter((value): value is string => typeof value === 'string')
    .map((value) => value.trim())
    .filter(Boolean)
    .filter(isPlatformRole);
}
